/** User-facing connection terminology (backend models unchanged). */
export const ADD_CONNECTION = 'Add connection';
export const ADD_FAMILY_CONNECTION = 'Add family connection';
export const FAMILY_CONNECTIONS = 'Family connections';
export const ARCHIVE_CONNECTION = 'Archive connection';

export function linkOutcomeMessage(profileType, linked, { identityStatus } = {}) {
  const isPrivate = identityStatus === 'private_placeholder';
  if (linked) {
    if (isPrivate) {
      return 'Added to your private archive and linked on the family tree. They can be invited to claim their profile later.';
    }
    return 'Connection added and linked on the family tree.';
  }
  if (profileType === 'pet') {
    return 'Pet saved in your archive list (not on the genealogical tree).';
  }
  if (profileType === 'companion') {
    return 'Archive connection saved (not on the genealogical tree). Link family tree connections from their profile if needed.';
  }
  if (isPrivate) {
    return 'Added to your private archive. Open their profile to link parents, partners, or children — invite them to claim it when ready.';
  }
  return 'Family connection added. Open their profile to link parents, partners, or children next.';
}

export const LINK_EXISTING_CONNECTION_HINT =
  'You are linking someone already in your archive. Inviting them to claim or share their profile is a separate step.';

export const GROW_BRANCH_COPY =
  'Grow this branch — link someone already in the archive, or add a new person as a private placeholder until they join.';
